<template>
  <div class="gameplan">
    <div class="normal_box">
      <div class="item_detail select_item_red">
        <span v-if="item.needVerify==1">需要场勘 / </span>
        <span v-else>不需要场勘 / </span>
        <span v-if="item.needConstruct==1">需要搭建</span>
        <span v-else>不需要搭建</span>
      </div>
      <div class="item_detail"><span class="item_title">是否需要SPR  </span>{{item.needSpr==1?'是':'否'}}</div>
      <!-- <div class="item_detail"><span class="item_title">是否需要督导打卡  </span>{{item.needSupervisor==1?'是':'否'}}</div> -->
      <div class="item_detail" ><span class="item_title">是否需要转场 </span><span>{{item.needTransitions==1?'是':'否'}}</span></div>
      <div class="item_detail" v-if="item.themeDecorates"><span class="item_title">装饰点位  </span><span>{{getThemeDecorates(item.themeDecorates)}}</span></div>
      <div class="infoBox_cross_line_box">售点参与条件<div class="infoBox_cross_line"></div></div>
      <div class="item_detail" v-if="item.pocCountMin>1"><span class="item_title">最少关联售点数  </span><span>{{item.pocCountMin}}</span></div>
      <div class="item_detail"><span class="item_title">IGNITE查询规则配置  </span>
        <div class="ignite" v-if="igniteRuleDTOList.length>0">
          <div class="ignite-item" v-for="(item,index) of igniteRuleDTOList" :key="item.igniteRuleId">
            <div class="ignite-title">
              <div class="ignite-title-index" :span="4">规则限制{{index+1}}</div>
              <div :span="20" class="ignite-detail-box">
                (<div class="ignite-detail-bu" v-for="(buItem,buIndex) of item.igniteMappingDTOList" :key="buIndex"><span v-if="(buIndex!==0)">、</span>{{getName(buItem.buName)}}-{{getName(buItem.regionName)}}</div>)
              </div>
            </div>
            <el-row>
              <el-col :span="24">{{getIgnate(item.igniteRuleObj)}}</el-col>
            </el-row>
          </div>
        </div>
        <div v-else>无IGNITE查询规则限制</div>
      </div>
      <div class="item_detail" v-if="item.needTransitions==0"><span class="item_title">每{{ getUnits('活动') }}执行活动天数 </span><span>{{item.perExecDays}}</span></div>
      <div class="item_detail" v-else><span class="item_title">道具数量设置 </span><span>{{item.itemQuantity}}</span></div>
      <div class="item_detail">
        <span class="item_title">
          <div>额度分配信息</div>
          <div class="edit-btn" v-if="(isBU&&subAssignList.length>0)||(isHQ&&hasQty&&item.isShow&&isShowEdit)" @click="showEditDialog()">编辑</div>
        </span>
        <div>

     <!--      <el-table :data="subAssignList" border :show-header="false" :span-method="objectSpanMethod" v-if="isHQ">
          <el-table-column label="bu" align="center" prop="buName" />
          <el-table-column align="center" prop="themeChannelName">
            <template slot-scope="{ row }">
              <div>{{(isHQ&&getName(row.buName))||(isBU&&getName(row.regionName))}}：{{row.assignQty}}场</div>
            </template>
          </el-table-column>
           <el-table-column align="center" width="250">
            <template slot-scope="{ row }">
              <div class="item_assign_second" v-if="row.regionAssignList&&row.regionAssignList.length>0">
                <div class="item_assign_second_item" v-for="row of row.regionAssignList" :key="row.regionCode">
                  {{getName(row.regionName)}}：{{row.assignQty}}场；
                </div>
              </div>
            </template>
          </el-table-column>
       <el-table-column align="center" width="250">
            <template slot-scope="{ row }">
              <div class="item_assign_second" v-if="row.regionAssignList&&row.regionAssignList.length>0">
                <div class="item_assign_second_item" v-for="row of row.regionAssignList" :key="row.regionCode">
                  {{getName(row.regionName)}}：{{row.assignQty}}场；
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column align="center" width="250">
            <template slot-scope="{ row }">
              <div class="item_assign_second" v-if="row.regionAssignList&&row.regionAssignList.length>0">
                <div class="item_assign_second_item" v-for="row of row.regionAssignList" :key="row.regionCode">
                  {{getName(row.regionName)}}：{{row.assignQty}}场；
                </div>
              </div>
            </template>
          </el-table-column>
          </el-table> -->

          <div v-if="isHQ">
            <div class="session-item" v-for="(session,key) in subAssignMap" :key="key">
              <!-- <div class="item-title-style">{{key}}</div> -->
              <el-table :data="bu.regionAssignList||[bu]" v-for="(bu,i) of session" :key="bu.bucode" border :show-header="false" :span-method="(param)=>objectSpanMethod(param,bu)" :cell-style="{'text-align':'center'}">
                <el-table-column align="center" width="200px" >
                  <template slot-scope="{  }">
                    <div>{{getName(bu.buName)}}：{{bu.assignQty}}  {{ getUnits() }}
                      <div v-if="session[i].regionAssignList">(已提报：<span class="submitCountQty">{{bu.submitCountQty}} {{ getUnits() }} </span>)</div>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column align="center" width="280">
                  <template slot-scope="{ row, }">
                    <div class="item_assign_second" v-if="session[i].regionAssignList">
                      {{getName(row.regionName)}}：{{row.assignQty}} {{ getUnits() }} (已提报：<span class="submitCountQty">{{row.submitCountQty}} {{ getUnits() }}</span>)
                    </div>
                  </template>
                </el-table-column>
                <el-table-column align="center" width="280">
                  <template slot-scope="{ row }">
                    <div class="item_assign_second" v-if="row.areaAssignList">
                      <div class="item_assign_second_item" v-for="(area,areaI) of row.areaAssignList" :key="area.areaCode">
                        <span v-if="areaI!==0">、</span>
                        {{getName(area.areaName)}}(已提报：<span class="submitCountQty">{{area.submitCountQty}} {{ getUnits() }}</span>)
                      </div>
                    </div>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>

          <div v-if="(isBU&&curAssignInfo.length>0)">
            <div class="session-item" v-for="session of curAssignInfo" :key="session.displayDate">
              <!-- <div class="item-title-style">{{session.displayDate}}</div> -->
              <!-- <div>{{seesion.assignStartTime}}-{{session.assignEndTime}}</div> -->
                <el-table :data="session.subAssignList" border :show-header="false" :span-method="(param)=>objectSpanMethod(param,session)" :cell-style="{'text-align':'center'}">
                  <el-table-column align="center" width="150px" >
                    <template slot-scope="{ row,$index }">
                      <div v-if="$index===0">
                        {{getName(session.buName)||getName(row.buName)}}：{{session.assignQty}} {{ getUnits() }}
                        <div>(已提报：<span class="submitCountQty">{{session.submitCountQty}} {{ getUnits() }} </span>)</div>
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column align="center" width="280">
                    <template slot-scope="{ row }">
                      <div class="item_assign_second" >
                        {{getName(row.regionName)}}：{{row.assignQty}} {{ getUnits() }} (已提报：<span class="submitCountQty">{{row.submitCountQty}} {{ getUnits() }}</span>)
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column align="center" width="320">
                    <template slot-scope="{ row }">
                      <div class="item_assign_second" >
                        <div class="item_assign_second" >
                          <div class="item_assign_second_item" v-for="area of row.areaAssignList" :key="area.areaCode">
                            {{getName(area.areaName)}}(已提报：<span class="submitCountQty">{{area.submitCountQty}} {{ getUnits() }} </span>)
                          </div>
                        </div>
                      </div>
                    </template>
                  </el-table-column>
                </el-table>
            </div>
          </div>

          <div v-if="(isBU&&curAssignInfo.length==0)">
            <div class="session-item" v-for="(session,key) in subAssignMap" :key="session.displayDate">
              <!-- <div class="item-title-style">{{key}}</div> -->
              <!-- <div>{{seesion.assignStartTime}}-{{session.assignEndTime}}</div> -->
                <el-table :data="session" border :show-header="false" :span-method="(param)=>objectSpanMethod(param,key)" :cell-style="{'text-align':'center'}">
                  <el-table-column align="center" width="150px" >
                    <template slot-scope="{ row,$index }">
                      <div v-if="$index===0">
                        {{getName(session.buName)||getName(row.buName)}}：{{getTotalAssignQty(key)}} {{ getUnits() }}
                        <div>(已提报：<span class="submitCountQty">{{getTotalSubmit(key)}} {{ getUnits() }} </span>)</div>
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column align="center" width="280">
                    <template slot-scope="{ row }">
                      <div class="item_assign_second" >
                        {{getName(row.regionName)}}：{{row.assignQty}} {{ getUnits() }} (已提报：<span class="submitCountQty">{{(row.submitCountQty||0)}} {{ getUnits() }} </span>)
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column align="center" width="320">
                    <template slot-scope="{ row }">
                      <div class="item_assign_second" >
                        <div class="item_assign_second" >
                          <div class="item_assign_second_item" v-for="area of row.areaAssignList" :key="area.areaCode">
                            {{getName(area.areaName)}}(已提报：<span class="submitCountQty">{{area.submitCountQty}} {{ getUnits() }} </span>)
                          </div>
                        </div>
                      </div>
                    </template>
                  </el-table-column>
                </el-table>
            </div>
          </div>

           <!-- <table class="item_assign" align="center" border="1" cellspacing="0" cellpadding="1">
                <tbody>
                  <tr v-for="assignItem of subAssignList" :key="assignItem.buCode">
                      <td :rowspan="assignItem.regionAssignList.length">{{(isHQ&&getName(assignItem.buName))||(isBU&&getName(assignItem.regionName))}}：{{assignItem.assignQty}}场</td>
                     <span v-for="regionItem of assignItem.regionAssignList" :key="regionItem.regionCode">
                        <td >{{getName(regionItem.regionName)}}：{{regionItem.assignQty}}场</td>
                        <td v-for="areaItem of regionItem.areaAssignList" :key="areaItem.areaCode">{{getName(areaItem.areaName)}}：{{areaItem.assignQty}}场</td>
                      </span>
                  </tr>
                </tbody>
            </table> -->

          <!-- <div v-if="isHQ">
            <div v-for="assignItem of subAssignList" :key="assignItem.buCode" class="item_assign">
              <div class="item_assign_first">{{(isHQ&&getName(assignItem.buName))||(isBU&&getName(assignItem.regionName))}}：{{assignItem.assignQty}}场</div>
              <div class="item_assign_second" v-if="assignItem.regionAssignList&&assignItem.regionAssignList.length>0">
                <div class="item_assign_second_item" v-for="regionItem of assignItem.regionAssignList" :key="regionItem.regionCode">
                  {{getName(regionItem.regionName)}}：{{regionItem.assignQty}}场
                  <div class="item_assign_second" v-if="regionItem.areaAssignList&&regionItem.areaAssignList.length>0">
                    <div class="item_assign_second_item" v-for="areaItem of regionItem.areaAssignList" :key="areaItem.areaCode">
                      {{getName(areaItem.areaName)}}：{{areaItem.assignQty}}场
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div> -->
          <!-- <div v-if="isBU" class="item_assign">
            <div v-if="curAssignInfo.assignQty" class="item_assign_first">{{getName(curAssignInfo.buName)}}：{{curAssignInfo.assignQty}}场</div>
            <div class="item_assign_second">
              <div class="item_assign_second_item" v-for="assignItem of subAssignList" :key="assignItem.regionCode">
                {{getName(assignItem.regionName)}}：{{assignItem.assignQty}}场
                <div class="item_assign_second" v-if="assignItem.areaAssignList&&assignItem.areaAssignList.length>0">
                  <div class="item_assign_second_item" v-for="areaItem of assignItem.areaAssignList" :key="areaItem.areaCode">
                    {{getName(areaItem.areaName)}}：{{areaItem.assignQty}}场
                  </div>
                </div>
              </div>
            </div>
          </div> -->
          <div v-if="isRegion" class="item_assign">
            <div v-for="(session,index) of curAssignInfo" :key="index">
              <!-- <div class="item-title-style">{{ session.assignStartTime | parseTime("{y}-{m}-{d}") }} 至 {{ session.assignEndTime | parseTime("{y}-{m}-{d}") }}</div> -->
              <div class="item_assign_first_box" v-if="(session.subAssignList&&session.subAssignList.length>0)">
                <div class="item_assign_first" v-for="item of session.subAssignList" :key="item.areaCode">{{getName(item.areaName)}}：{{item.assignQty}} {{ getUnits() }}</div>
              </div>
              <div class="item_assign_first_box" v-else>
                <div class="item_assign_first">{{getName(session.regionName)}}：{{session.assignQty}} {{ getUnits() }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <el-dialog
      :visible.sync="showConfirmDialog" :before-close="handleDialogClose" width="850px" >
      <div slot="title" class="dialog-title">
        <div>{{ needTransitions===0?'不需要转场':'需要转场' }}</div>
      </div>
      <div class="assign-region-box" v-if="inputData.length>0">
        <div v-if="(curAssignInfo&&curAssignInfo.length>0)">
          <div v-for="(session,index) of curAssignInfo" :key="session.displayDate">
            <div class="session-info-box">
              <!-- <div class="session-time">{{session.displayDate}}</div> -->
              <div class="assign-number">待配置{{ getUnits() }}数：{{getResult(index)}}</div>
            </div>
            <div class="assign-region-item-box">
              <ConfigDetailAssignUpdate :subAssignListInfo="session.subAssignList" :itemKey="index" @handleSubmitAssign="handleSubmitAssign" :units="getUnits()"/>
            </div>
          </div>
        </div>
        <div v-else>
          <div v-for="(session,index) of subAssignList" :key="session.displayDate">
            <div class="session-info-box">
              <!-- <div class="session-time">{{ session[0].assignStartTime | parseTime("{y}-{m}-{d}") }} 至 {{ session[0].assignEndTime | parseTime("{y}-{m}-{d}") }}</div> -->
              <div class="assign-number">待配置{{ getUnits() }}数：{{getResult(index)}}</div>
            </div>
            <div class="assign-region-item-box">
              <ConfigDetailAssignUpdate :subAssignListInfo="session" :needTransitions="needTransitions" :itemKey="index" @handleSubmitAssign="handleSubmitAssign" :units="getUnits()" />
            </div>
          </div>
        </div>
      </div>
      <!-- <div class="assign-region-box" v-if="inputData.length>0">
        <div v-for="(session,index) of subAssignList" :key="session.displayDate">
          <div class="session-info-box">
            <div class="session-time">{{ session[0].assignStartTime | parseTime("{y}-{m}-{d}") }} 至 {{ session[0].assignEndTime | parseTime("{y}-{m}-{d}") }}</div>
            <div class="assign-number">待配置场数：{{getResult(index)}}</div>
          </div>
          <div class="assign-region-item-box">
            <ConfigDetailAssignUpdate :subAssignListInfo="session" :itemKey="index" @handleSubmitAssign="handleSubmitAssign" />
          </div>
        </div>
      </div> -->
      <div class="warning" v-show="showError1">{{isHQ?`待配置${getUnits()}数需为0`:`额度分配不可小于已提报数，且待配置${getUnits()}数不可小于0`}}</div>
      <div class="warning" v-show="showError2">{{isHQ?`额度分配必填，且待配置${getUnits()}数需大于0`:`额度分配必填，且待配置${getUnits()}数需大于0`}}</div>
      <div slot="footer" class="dialog-footer">
        <div v-if="(showError2||showError1)" :class="['submit_item_btn','submit_item_btn_disabled']">确认修改</div>
        <div v-else class="submit_item_btn" @click="submit()">确认修改</div>
      </div>
    </el-dialog>

  </div>
</template>

<script>
// import ConfigDetailBu from './config-detail-assign.vue'
import { mapGetters } from 'vuex'
import { getDateFromString } from '@/filters'
import ConfigDetailAssignUpdate from './config-detail-assign-update.vue'
import gameplanApi from "@/api/gameplan";
export default {
  components:{
    ConfigDetailAssignUpdate
  },
  props: {
    themeStyles1: {
      type: Object,
      default: () => { }
    },
    baseConfig: {
      type: Object,
      default: () => { }
    },
    secondTabItemName: {
      type: String,
      default: ''
    },
    fullConfig: { type: Array, default: () => [] },
    assignBuList:{ type: Array, default: () => [] },
    assignListParent:{ type: Array, default: () => [] },
    assignAreaList:{ type: Array, default: () => [] },
    assignRegionList: { type: Array, default: () => [] },
    igniteOptions: { type: Object, default: () => { } },
    saveDetailList: { type: Array, default: () => [] },
    allInfo: { type: Object, default: () => { } },
    detailListLength:{ type: Number, default: 0 },
    buToCity:{ type: Number, default: 0 },
  },
  data() {
    return {
      employeeLevel: '',
      hidden: false,
      radio: '',
      params: {
        needVerify: '',
        needConstruct: '',
        needSpr: '',
        themeDecorateCodes: [],
        pocCountMin: '',
        pocRelateType:2,
        igniteStatus:[],
        openStatus:[],
        channel:[],
        bizForm:[],
        pocGrade:[],
        salesVolume:[],
        igniteRuleObj: {
          igniteStatus:[],
        },
      },
      themeDetail:{},
      igniteRuleObj: {
        igniteStatus:['01'],
        region:''
      },
      editRules: {
        needSpr: [{ required: true, message: "请选择是或否", trigger: "blur" }],
        themeDecorateCodes: [{ required: true, message: "请选择装饰点位", trigger: "blur" }],
        pocCountMin: [{ required: true, message: "请输入售点数量", trigger: "blur" }],
        igniteStatus: [{ required: true, message: "请选择IGNITE状态", }],
        openStatus: [{ required: true, message: "请选择售点状态", trigger: "change" }],
        channel: [{ required: true, message: "请选择渠道设置", trigger: "change" }],
        bizForm: [{ required: true, message: "请选择业态", trigger: "change" }],
        pocGrade: [{ required: true, message: "请选择档次", trigger: "change" }],
        salesVolume: [{ required: true, message: "请选择销售潜力", trigger: "change" }],
        region: [
            { required: true, message: '请选择活动区域', trigger: 'change' }
          ],
      },
      radioList: [
        { key: '是', value: 1 },
        { key: '否', value: 0 },
      ],
      mandatoryDecorates: [],
      themeLevelsInfo: {},
      subAssignItem:{},
      subAssignList:[],
      assignBu:[],
      showDecorates:[],
      isSave:false,
      saveConfig:{},
      themeStyles:{},
      assignList:[],
      result:0,
      isError:false,
      showConfirmDialog:false,
      inputData:[],
      showError1:false,
      showError2:false,
      count:0,
      total:0,
      remain:0,
      curAssignInfo:[],
      submitAssignList:[],
      needTransitions:0
    }
  },
  computed:{
    ...mapGetters(['userInfo']),
    isHQ(){
      return this.employeeLevel>=90
    },
    isBU(){
      return this.employeeLevel>=60&&this.employeeLevel<90
    },
    isRegion(){
      return this.employeeLevel>=45&&this.employeeLevel<60
    },
    hasQty(){
      // let total = 0
      // let assign = 0
      // for(let i=0;i<this.subAssignList.length;i++){
      //   let bu = this.subAssignList[i]
      //   total += Number(bu.assignQty)
      //   if(bu.regionAssignList&&bu.regionAssignList.length>0){
      //     for(let j=0;j<bu.regionAssignList.length;j++){
      //       let region = bu.regionAssignList[j]
      //       assign += Number(region.assignQty)
      //     }
      //   }
      // }
      // return total>assign
      return true
    },
    isShowEdit(){
      // let total = 0
      // let assign = 0
      // this.subAssignList.map(item=>{
      //   if(item.regionAssignList&&item.regionAssignList.length>0){
      //     total+=Number(item.assignQty)
      //     assign+=Number(item.totalCountQty)
      //   }
      // })
      // return !(total===assign)
      return true
    }
  },
  created() {
    this.assignList = [...this.assignListParent]
    this.employeeLevel = this.userInfo.employeeLevel
    if(this.employeeLevel>=90){
      this.assignList = this.assignBuList || []
    }else if(this.isBU){
      if(this.buToCity==0){
        this.assignList = this.assignRegionList || []
      }
    }else if(this.employeeLevel<60){
      this.assignList = this.assignAreaList
    }
    this.item = this.allInfo.themeDetail
    if(this.allInfo.subAssignList&&this.allInfo.subAssignList.length>0){
      if(this.isHQ||this.isBU){
        this.subAssignList = this.allInfo.subAssignList.map((item,index)=>{
          let data = item.regionAssignList
          if(data&&data.length>0){
            data.map((region)=>{
              region.index=index
            })
          }
          return item
        })
      }
    }
    //this.subAssignList = [...this.allInfo.subAssignList,...this.subAssignList1,...this.subAssignList1]
    this.curAssignInfo= this.allInfo.curAssignInfo || []
    this.item.quantity = (this.allInfo.curAssignInfo&&this.allInfo.curAssignInfo.assignQty)|| 0
    this.saveSubAssignList = this.allInfo.subAssignList || []
    this.srcAssignId = (this.allInfo.curAssignInfo&&this.allInfo.curAssignInfo.assignId) || ''
    this.subAssignMap = this.allInfo.subAssignMap || {}
    this.igniteRuleDTOList = this.allInfo.igniteRuleDTOList || []
    let assignItemKey = 0
    if(this.allInfo.curAssignList&&this.allInfo.curAssignList.length>0){
      this.allInfo.curAssignList.forEach(session => {
        let data = {...session}
        data.assignItemKey=assignItemKey
        data.needTransitions=this.item.needTransitions
        data.subAssignList=[]
        if(this.allInfo.subAssignMap){
          let keyList = Object.keys(this.allInfo.subAssignMap)
          for(let item of keyList){
            //console.log(item);
            let dateList = item.split('至')
            if(session.assignStartTime==getDateFromString(dateList[0])&&session.assignEndTime==getDateFromString(dateList[1])){
              data.displayDate = item
              data.subAssignList=this.allInfo.subAssignMap[item]
            }
          }
        }
        this.curAssignInfo.splice(this.curAssignInfo.length,0,data)
        assignItemKey++
      })
    }else if(this.allInfo.subAssignMap){
      if(this.isHQ){
        let keyList = Object.keys(this.allInfo.subAssignMap)
        this.subAssignList = keyList.map(key=>{
          // this.allInfo.subAssignMap[key].displayDate = key
          return this.allInfo.subAssignMap[key]
        })
        //console.log(this.subAssignList);
      }else if(this.isBU){
        let keyList = Object.keys(this.allInfo.subAssignMap)
        this.subAssignList = keyList.map(key=>{
          // this.allInfo.subAssignMap[key].displayDate = key
          return this.allInfo.subAssignMap[key]
        })
      }
    }
    this.needTransitions = this.item.needTransitions
    //this.finalSubAssignList = {'key':this.allInfo.subAssignList}
  },
  methods: {
    objectSpanMethod({ row, column, rowIndex, columnIndex },session) {
      if(this.isHQ){
        if (columnIndex === 0 ) {
          if(rowIndex===0){
            return {
              rowspan:session.regionAssignList&&session.regionAssignList.length || 1,
              colspan: 1
            }
          }else if(rowIndex!=0){
            return {
              rowspan:0,
              colspan:0
            }
          }
        } 
      }else if(this.isBU){
        if(this.curAssignInfo.length===0){
          if (columnIndex === 0 ) {
            if(rowIndex % (this.subAssignMap[session]&&this.subAssignMap[session].length) === 0){
              return {
                rowspan:this.subAssignMap[session]&&this.subAssignMap[session].length || 1,
                colspan: 1
              }
            }else if(rowIndex!=0){
              return {
                rowspan:0,
                colspan:0
              }
            }
          } 
        }else {
          if (columnIndex === 0) {
            if(rowIndex % (session.subAssignList&&session.subAssignList.length) === 0){
              return {
                rowspan:session.subAssignList&&session.subAssignList.length || 1,
                colspan: 1
              }
            }else if(rowIndex!=0){
              return {
                rowspan:0,
                colspan:0
              }
            }
          }
        }
      }
    },
    handleSubmitAssign(subAssignList,itemKey){
      this.showError1 = false
      //console.log(this.curAssignInfo);
      //console.log(subAssignList,itemKey);
      this.submitAssignList.splice(itemKey,1,subAssignList)
      this.submitAssignList[itemKey] = subAssignList
      //console.log(this.curAssignInfo[itemKey].assignQty);
      if(this.isBU){
        this.getResult(itemKey)
      }
    },
    getTotal(list,index){
      let total = 0
      total = list[index].reduce((pre,cur)=>{
        if(cur.assignStatus==100){
          return pre+Number(cur.assignQty)
        }else {
          return pre
        }
      },0)
      return total
    },
    getTotalAssignQty(key){
      let result = this.subAssignMap[key].reduce((pre,cur)=>{
        return pre + Number(cur.assignQty)
      },0)
      return result
    },
    getTotalSubmit(key){
      let result = this.subAssignMap[key].reduce((pre,cur)=>{
        return pre + Number(cur.submitCountQty)
      },0)
      return result
    },
    getResult(){
      let itemKey = 0
      let assignQty = 0
      if(this.curAssignInfo&&this.curAssignInfo.length>0){
        assignQty = this.curAssignInfo[itemKey].assignQty
      }else{
        assignQty = this.getTotal(this.subAssignList,itemKey)
      }
      //console.log(assignQty);
      //let assignQty = this.curAssignInfo[assignItemKey].assignQty
      let result = 0
      if(this.submitAssignList[itemKey]){
        result = this.getTotal(this.submitAssignList,itemKey)
      }
      if(this.isBU){
        if((assignQty-result)<0){
          this.showError1 = true
        }
      }else if(this.isHQ){
        if((assignQty-result)!=0){
          this.showError1 = true
        }
      }
      //console.log(this.submitAssignList);
      //console.log(result);
      return (assignQty - result)
    },
    submit(type){
      let result = []
      if(this.isBU){
        result = this.submitAssignList.reduce((pre,cur)=>{
          return pre.concat(cur)
        },[])
      }else if(this.isHQ){
        result = this.submitAssignList.reduce((pre,cur)=>{
          let data = []
          cur.forEach(item=>{
            if(item.assignStatus===100){
              data.push(item)
            }
          })
          return pre.concat(data)
        },[])
      }
      let themeDetail = {
        themeDetailId:this.item.themeDetailId,
        themeId:this.item.themeId
      }
      let params = {
        subAssignList:result,
        themeDetail,
        curAssignList : this.allInfo.curAssignList
      }
      //console.log(params);
 
      // let isValid = true
      // for(let item of this.inputData){
      //   if(item.assignQty){
      //     isValid = true
      //   }
      // }
      // if(!isValid){
      //   this.showError2 = true
      //   return
      // }
      // if(this.isHQ){
      //   result = this.inputData.filter(item=>{
      //     return item.assignStatus===100&&item.mappingStatus!==1
      //   })
      // }else {
      //   result = this.inputData
      // }
      // if(this.showError1||this.showError2) return
      this.$confirm('是否确认修改配额?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        confirmButtonClass: 'btn-red',
        type: 'warning'
      }).then(async() => {
        // let themeDetail = {
        //   themeDetailId:this.item.themeDetailId,
        //   themeId:this.item.themeId
        // }
        // let params = {
        //   subAssignList:result,
        //   themeDetail
        // }
        // console.log(params);
        const { data } = await gameplanApi.getGameplanThemeRelocation(params);
        if (data.resultCode === "0") {
          this.$message.success("修改成功！")
          window.location.reload()
        }
      }).catch(() => {
      });
    },
    getName(str){
      if(str){
          return str.split('|')[0] || str
      }else return ''
    },
    getCount(type){
      let result = 0
      for(let item of this.subAssignList){
        result += Number(item[type])
      }
      return result
    },
    getRegionQty(assignItem){
      let result = 0
      if(assignItem.regionAssignList){
        for(let item of assignItem.regionAssignList){
          result+=Number(item.assignQty)
        }
      }
      return result
    },
    getThemeDecorates(themeDecoratesList){
      let res = []
      for(let item of themeDecoratesList){
        res.push(item.decorateName)
      }
      return res.join('、')
    },
    getUnits(extra){
      let units = ''
      if(this.item.needTransitions===0){
        switch (this.item.pocRelateType) {
          case '0':
          units = (extra?extra:'')+'地点'
            break;
          case '1':
          units = '售点'
            break;
          default:
          units = '街区'
            break;
        }
      }else {
        units = '场'
      }
      return units
    },
    handleDialogClose(){
      this.inputData = []
      this.showConfirmDialog=false
    },
    showEditDialog(){
      this.showError1 = false
      this.showError2 = false
      this.inputData = []
      let count = 0
      if(this.isBU){
        this.subAssignList.map(item=>{
          let data = {
            assignQty:item.assignQty,
            regionCode:item.regionCode
          }
          count+=item.assignQty
          this.inputData.push(data)
        })
      }else if(this.isHQ){
        this.subAssignList.map(item=>{
          let data = {
            assignQty:item.assignQty,
            buCode:item.buCode,
            assignStatus:item.assignStatus,
          }
          count+=item.assignQty
          this.inputData.push(data)
        })
      }
      this.total = this.subAssignList.assignQty || count
      this.count = count
      this.remain = this.subAssignList.assignQty - count || 0
      this.showConfirmDialog = true
    },
    handleInputAssign(index){
      this.showError1 = false
      this.showError2 = false
      this.inputData[index].assignQty=this.inputData[index].assignQty||0
      let sum = this.inputData.reduce((pre,cur)=>{
        return pre+=Number(cur.assignQty)
      },0)
      this.remain = this.total - sum
      for(let i=0;i<this.inputData.length;i++){
        if(this.inputData[i].assignQty<this.getRegionQty(this.subAssignList[i])||this.inputData[i].assignQty<this.subAssignList[i].submitCountQty){
          this.showError1 = true
          return
        }
      }
      if(this.isHQ){
        //console.log(this.inputData[index].assignQty);
        //console.log(this.getRegionQty(this.subAssignList[index]));
        if(this.inputData[index].assignQty<this.getRegionQty(this.subAssignList[index])||this.remain<0){
          this.showError1 = true
          return
        }
        this.showError2 = false
      }else {
        if(this.inputData[index].assignQty<this.subAssignList[index].submitCountQty||this.remain<0){
          this.showError1 = true
          return
        }
        this.showError1 = false
        if(this.remain < 0){
          this.showError2 = true
          return
        }
        this.showError2 = false
      }

    },
    getIgnate(igniteRuleObj){
      let res = ''
      for(let item in igniteRuleObj){
        let selectedList = igniteRuleObj[item]
        let detail = this.igniteOptions[item]
        if(selectedList&&selectedList.length>0){
          for(let selected of selectedList){
            switch (item) {
              case 'bizForm':
              res.indexOf('| 业态：')===-1?res+='| 业态：':res+=''
                //res+='业态：'
                break;
              case 'channel':
                res.indexOf('| 渠道设置：')===-1?res+='| 渠道设置：':res+=''
                break;
              case 'igniteStatus':
              res.indexOf('IGNATE状态：')===-1?res+='IGNATE状态：':res+=''
               // res+='IGNATE状态：'
                break;
              case 'openStatus':
              res.indexOf('售点状态：')===-1?res+='售点状态：':res+=''
               // res+='售点状态：'
                break;
              case 'pocGrade':
              res.indexOf('| 档次：')===-1?res+='| 档次：':res+=''
               // res+='档次：'
                break;
              case 'salesVolume':
              res.indexOf('| 销售潜力：')===-1?res+='| 销售潜力：':res+=''
                //res+='销售潜力：'
                break;
              default:
                break;
            }
            if(detail&&detail[selected]){
              res+= detail[selected] + " " + (item=="salesVolume"?"":"")
            }
          }
        }
      }
      return res
    },
  }

}
</script>

<style lang="scss" scoped>
::v-deep.el-radio {
  margin-right: 60px;

  .el-radio__input {
    display: inline-block;
    padding-right: 5px;

    &.is-checked .el-radio__inner {
      border-color: $base-red;
      background: $base-red;
    }

    &.is-checked+.el-radio__label {
      color: #101010;
    }
  }
}

::v-deep .el-form-item {
  margin: 3px 0;

  .el-form-item__label {
    color: black;
    font-weight: 600;
  }

  .el-form-item__content {
    line-height: 35px !important;
  }
}

::v-deep .el-input__inner {
  width: 200px;
}
::v-deep .ignite_item_select .el-form-item__content {
  width: calc(100% - 180px);
}
::v-deep .ignite_item_select .el-select {
  margin: 0 20px 10px 0;
}
::v-deep .el-input__inner{
  height: 36px;
  line-height: 36px;
}
::v-deep .el-select {
  margin: 0 20px 20px 0;
}

.select_item_red {
    color: #e70027 !important;
    font-weight: bold;
}
.infoBox_cross_line_box {
  margin: -10px 0px 30px 15px;
  font-weight: 600;
  color: rgb(182, 182, 182);
  .infoBox_cross_line{
    width:800px;
    height: 1px;
    background-color: rgb(238, 238, 238);
    margin: -9px 0 0 120px;
  }
}
.display_block{
  display:block;
}
.el-form-item{
  width: 100%;
}
.display_flex{
    display: flex;
  }

.sp-el-form{
  width: 70%;
  position: relative;
  left: 180px;
  margin-top: -40px;
  display: flex;
  flex-wrap: wrap;
  // .el-form-item{
  // width: 180px;
  // margin:10px 15px 10px 0;
  // }
}
::v-deep .el-form-item__error{
  width: 150px;
}
::v-deep .ignite_item_select .el-select {
    margin: 0 20px 0px 0;
}

.item_title{
    display: inline-block;
    min-width: 200px !important;
    font-weight: 700;
    color: black;
  }
.assign-detail{
  font-size: 13px;
  font-weight: 500;
  line-height: 20px;
}
  .item_detail{
    //width: 900px;
    font-size: 15px;
    margin: 0px 15px 30px 15px;
    display: flex;
    .edit-btn{
      cursor: pointer;
      margin-top: 5px;
      font-size: 12px;
      width: 50px;
      text-align: center;
      padding: 8px 5px;
      color: rgb(37, 158, 228);
      border: 1px solid rgb(37, 158, 228);
      border-radius: 4px;
      line-height: 12px;
    }
  }

  .region-city-item{
    width: 100%;
    margin-bottom:20px;
    .bu-name{
      width: 100%;
      margin-bottom: 15px;
    }
    .font-weight-bold{
      display:inline-block;
      font-weight: bold;
      font-size: 15px;
      width: 100px;
    }
    .line{
      display:inline-block;
      width: 650px;
      height: 1px;
      background-color:rgb(231, 231, 231);
      margin:-10px 0 0 30px;
    }
  }

.item_assign{
  //display: flex;
  margin:0 40px 0px 0;
  // border: 1px solid grey;
}
.item_assign_first{
  margin:0 30px 30px 0;
}
.item_assign_second{
  display: flex;
  flex-wrap: wrap;
}
.ignate{
  display: inline-block;
  width: calc(100% - 350px);
  line-height: 20px;
}
.warning{
  display: inline-block;
  margin:0px 0 0 20px;
  color: red;
}
.session-info-box{
  display: flex;
}
.session-time{
  font-size: 16px;
  font-weight: 600;
  color: black;
  margin:0px 0 8px 10px;
}
.assign-region-item-box{
  display: flex;
  margin-bottom: 20px;
}
.assign-region-item{
  width: 200px;
  margin: 15px 20px 15px 20px;
  padding-right:30px;
}
.assign-region-title{
  width: 100%;
  font-size: 15px;
  //font-weight: 600;
  color: black;
  margin-bottom: 8px;
}
.assign-region-info{
  font-size: 12px;
  color: #cd1231;
  margin-top: 8px;
}
.assign-number{
  margin: -10px 0 10px 20px;
  font-weight: 600;
  color: black;
  font-size: 16px;
}
::v-deep .el-dialog__footer {
    display: flex;
    justify-content: flex-end;
    padding: 10px 20px 10px;
}
::v-deep .el-dialog__header{
  border-bottom:none;
  padding-top: 10px;
}
.submit_item_btn {
  cursor: pointer;
  padding: 0 10px;
  height: 30px;
  line-height: 30px;
  //width: 100px;
  border-radius: 5px;
  text-align: center;
  vertical-align: middle;
  color: white;
  background-color: rgb(204, 0, 0);
}
.submit_item_btn_disabled{
  background-color: $base-grey !important;
  cursor: no-drop;
}
::v-deep .el-table__body .el-table__row.hover-row td{
  background-color: white;
}
.submitCountQty{
  color: #0eb0fc;
}
::v-deep .el-table tbody tr:hover>td {
background-color:transparent !important
}
.session-item{
  margin-bottom: 20px;
}
.session-title{
  font-weight: 600;
  font-size: 14px;
  margin-bottom: 10px;
}
.item-title-style{
  margin-bottom: 10px;
  font-weight: 600;
}
.ignite-title-index{
  font-weight: 600;
  min-width: 100px;
}
.ignite-title{
  display: flex;
  margin-bottom: 10px;
  width: 750px;
}
.item_assign_first_box{
  display: flex;
  flex-wrap: wrap;
}
.ignite-detail-box{
  display: flex;
  flex-wrap: wrap;
  color: #cd1231;
  font-weight: 500;
}
.ignite-item{
  margin-bottom: 30px;
}
.dialog-title{
  font-size: 18px;
  color: #cd1231;
  font-weight: 600;
  margin-top: 10px;
}
</style>